import PropTypes from "prop-types"


const properties = {
  documentsUrl: PropTypes.string,
  investmentSignThankYouUrl: PropTypes.string,
  investmentSignUrl: PropTypes.string,
  investmentUrl: PropTypes.string,
  portalUrl: PropTypes.string,
  signInUrl: PropTypes.string,
  softCommitmentUrl: PropTypes.string
}

const LinkTemplatesShape = PropTypes.exact(properties)

export default LinkTemplatesShape
export { properties }
